export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5360.24e41214.jpg";